/** @format */
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    EventEmitter,
    inject,
    Inject,
    input,
    Optional,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { CreditRange, CustomCourseUnitAttainment, OtmId } from 'common-typescript/types';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';
import { CustomCourseUnitAttainmentStateObject } from '../../service/plan-state.service';
import { Action } from '../../study-boxes/study-action-box/study-action-box.component';
import { StudyBoxType } from '../../study-boxes/study-box/study-box.component';
import { PlanStructureContext } from '../plan-structure-context';

@Component({
    selector: 'sis-plan-structure-custom-course-unit-attainment',
    templateUrl: './plan-structure-custom-course-unit-attainment.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureCustomCourseUnitAttainmentComponent {
    readonly customCourseUnitAttainment = input.required<CustomCourseUnitAttainment>();
    readonly headingLevel = input.required<number>();
    readonly selected = input<boolean>();
    readonly action = input<Action>();
    readonly nameClickable = input<boolean>(true);
    @Output() actionChange? = new EventEmitter<OtmId>();

    private readonly planStructureContext = inject(PlanStructureContext);

    protected readonly customCourseUnitAttainmentStateObject = computed<CustomCourseUnitAttainmentStateObject | undefined>(
        () => this.planStructureContext.planStateObject().customCourseUnitAttainments?.[this.customCourseUnitAttainment()?.id],
    );
    protected readonly visibleCredits = computed<CreditRange | undefined>(() => {
        const customCourseUnitAttainment = this.customCourseUnitAttainment();
        return customCourseUnitAttainment
            ? { min: customCourseUnitAttainment.credits, max: customCourseUnitAttainment.credits }
            : undefined;
    });
    readonly studyBoxType = StudyBoxType.customAttainment;

    constructor(@Optional() @Inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN) private planActionsService: PlanActionsService) {}

    openCustomCourseUnitAttainmentInfoModal() {
        this.planActionsService?.openCustomCourseUnitAttainmentInfoModal(this.customCourseUnitAttainment());
    }
}
